import React from "react";
import {
  formatAadhaarNumber,
  hasKycDocumentImages,
  isOtpKycRecord,
  kycDocumentImageSrc,
  kycMethodLabel,
} from "../../utils/kycDisplay";

export function KycMethodBadge({ item }) {
  const otp = isOtpKycRecord(item);
  return (
    <span className={`badge ${otp ? "badge-info" : "badge-secondary"}`}>
      {kycMethodLabel(item)}
    </span>
  );
}

export function KycAadhaarCell({ item }) {
  return <span>{formatAadhaarNumber(item?.Number)}</span>;
}

export function KycOtpDetails({ item }) {
  if (!isOtpKycRecord(item)) return null;
  return (
    <div className="lp-kyc-otp-details small">
      <div className="mb-1">
        <span className="badge badge-info">Online OTP KYC</span>
      </div>
      <div className="text-muted">Verified via Aadhaar OTP (no photo upload)</div>
      {item.Gender ? (
        <div className="mt-1">
          <strong>Gender:</strong> {item.Gender}
        </div>
      ) : null}
      {item.Address ? (
        <div className="mt-1 text-break">
          <strong>Address:</strong> {item.Address}
        </div>
      ) : null}
    </div>
  );
}

export function KycDocumentImage({ item, baseUrl, side, index, className = "img kyc-doc-img" }) {
  if (isOtpKycRecord(item)) {
    return <span className="text-muted small">—</span>;
  }
  const path = side === "back" ? item.back : item.front;
  const src = kycDocumentImageSrc(baseUrl, path);
  if (!src || !hasKycDocumentImages(item)) {
    return <span className="text-muted small">—</span>;
  }
  return (
    <div className="img-panel">
      <img
        className={className}
        src={src}
        alt={`kyc ${side}`}
        style={{
          borderRadius: "5px",
          width: "4rem",
          height: "4rem",
          objectFit: "cover",
        }}
        id={`kyc-${side}-${index}`}
      />
    </div>
  );
}
